export default {
  meta: {
    title: 'Ventura Software | Mobile apps and platforms, built in Montevideo',
    description:
      'A software studio in Montevideo, Uruguay. We build mobile apps and the platforms behind them, from first version to production. Since 2023.',
  },
  howWeWork: {
    eyebrow: 'How we work',
    title: 'Our working day overlaps with yours',
    body:
      'Montevideo is UTC-3 all year, with no daylight saving time. That is 1 to 2 hours ahead of US Eastern, and our mornings overlap with Central European afternoons.',
    languages: 'We work in English and Spanish.',
    engagement: {
      start: {
        title: 'It starts with a call',
        body: 'A free 30-minute call to understand what you need. Then we send you a proposal with scope, timeline and price.',
      },
      models: {
        title: 'Two ways to work together',
        body: 'We build the whole product end to end, or we add dedicated engineers to your team. You can meet them before they start.',
      },
      cadence: {
        title: 'Updates on your terms',
        body: 'We agree with each client how often to show progress: demos, written updates or a shared channel.',
      },
    },
    you: 'Your time',
    overlap: '{{count}} h overlap',
    legend: 'Bars show 9:00 to 18:00 local time in each city',
    cities: {
      montevideo: 'Montevideo',
      newYork: 'New York',
      sanFrancisco: 'San Francisco',
      london: 'London',
      berlin: 'Berlin',
    },
  },
  featured: {
    eyebrow: 'Selected work',
    title: 'Recent work',
    subtitle: 'Three products we built end to end and keep running.',
    seeAll: 'See all projects',
    items: {
      walo: 'Booking app and studio dashboard for a Pilates studio in Montevideo.',
      bethel: 'Member app, staff admin and QR check-in for a multi-location gym.',
      dmg: 'Lab information system that tracks every specimen from reception to signed report.',
    },
  },
  privacyPage: {
    eyebrow: 'Legal',
    title: 'Privacy policy',
    updated: 'Last updated: October 2026',
    intro:
      'This page explains what personal data the Ventura Software website (venturasoftware.dev) collects, why, and what you can do about it.',
    sections: [
      {
        title: 'What we collect',
        body: 'Only what you send us through the contact form: your name, your email address and your message. If you email us, message us on WhatsApp or book a call, we receive whatever you choose to share there.',
      },
      {
        title: 'How we use it',
        body: 'Only to reply to you and to follow up on the conversation you started. We do not sell your data, use it for advertising or add you to mailing lists.',
      },
      {
        title: 'Who processes it',
        body: 'The contact form is delivered to our inbox through EmailJS (emailjs.com). Calls are booked through Calendly (calendly.com) and WhatsApp messages go through WhatsApp (Meta). Each of these services has its own privacy policy. The site is hosted on Vercel, which processes technical request data such as IP addresses to serve the pages.',
      },
      {
        title: 'Cookies and tracking',
        body: 'This site does not use cookies, analytics or advertising trackers. Fonts and icons are served from our own domain. If you pick a language, that choice is saved in your browser so the site remembers it; it never leaves your device.',
      },
      {
        title: 'How long we keep it',
        body: 'We keep your messages for as long as we need them to handle your request and any work that follows from it. You can ask us to delete them at any time.',
      },
      {
        title: 'Your rights',
        body: 'You can ask us what data we hold about you, and ask us to correct or delete it, by writing to info@venturasoftware.dev.',
      },
    ],
    contactTitle: 'Contact',
    back: 'Back to home',
  },
};
